module.exports = __webpack_public_path__ + "static/media/pin.93c4cffc.svg";